import { render } from "./SubmissionHistoryWidget.vue?vue&type=template&id=ab8f005a"
import script from "./SubmissionHistoryWidget.vue?vue&type=script&lang=js"
export * from "./SubmissionHistoryWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__